<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md3 fill-height>
        <workload :workload="workload"></workload>
      </v-flex>
      <v-flex xs12 md3 fill-height>
        <absolute-workload :workload="2" :max-val="4" label="E-Parkplätze"></absolute-workload>
      </v-flex>
      <v-flex xs12 md3 fill-height>
        <absolute-workload :workload="1" :max-val="2" label="Behindertenparkplätze"></absolute-workload>
      </v-flex>
      <v-flex xs12 md3 fill-height>
        <absolute-workload :workload="18" :max-val="22" label="Normale Parkplätze"></absolute-workload>
      </v-flex>
      <v-flex xs12 md6>
        <line-chart
          :datasets="lineChart.datasets"
          :labels="lineChart.labels"
          data-label="Auslastung in %"
          @load="onChartLoaded">
        </line-chart>
      </v-flex>
      <v-flex xs12 md6>
        <v-card style="height: 100%">
          <v-card-text>
            <parking-table :data="parkingTable"></parking-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md3>
        <simple-statistic
          :value="statistics.averageWorkload"
          suffix="%"
          type="number"
          label="ø-Auslastung pro Tag">
        </simple-statistic>
      </v-flex>
      <v-flex xs12 md3>
        <simple-statistic
          :value="statistics.averageRotations"
          type="number"
          :decimals="1"
          label="Parkrotationen pro Tag">
        </simple-statistic>
      </v-flex>
      <v-flex xs12 md3>
        <simple-statistic
          :value="statistics.averageParkDuration"
          suffix="h"
          type="time"
          label="ø Parkdauer pro Tag">
        </simple-statistic>
      </v-flex>
      <v-flex xs12 md3>
        <simple-statistic
          :value="statistics.exceededParkings"
          type="number"
          label="Überschrittene Parkzeiten"
          color="error">
        </simple-statistic>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AbsoluteWorkload from '../components/Dashboard/AbsoluteWorkload.vue';
import Workload from '../components/Dashboard/Workload.vue';
import LineChart from '../components/Metrics/LineChart.vue';
import SimpleStatistic from '../components/Metrics/SimpleStatistic.vue';
import ParkingTable from '../components/Metrics/ParkingTable.vue';

export default {
  name: 'parking-lot-metrics',

  components: {
    AbsoluteWorkload,
    Workload,
    LineChart,
    SimpleStatistic,
    ParkingTable,
  },

  computed: {
    workload() {
      return this.$store.metrics.state.overview.workload;
    },
    lineChart() {
      return this.$store.metrics.state.overview.lineChart;
    },
    statistics() {
      return this.$store.metrics.state.detailed.statistics;
    },
    parkingTable() {
      return [
        {
          start: this.$moment().format('DD.MM.YYYY HH:mm'),
          end: this.$moment().add(1.2, 'hours').format('DD.MM.YYYY HH:mm'),
          duration: '01:12h',
        },
      ];
    },
  },

  methods: {
    onChartLoaded() {
      if (this.lineChart.datasets.length === 0) {
        // this.$store.metrics.commit('SET_RANDOM_CHART_DATA');
      }
    },
  },

  mounted() {
    this.$store.navigation.commit('SET_NAV_RIGHT_ELEMENTS', null);
    this.$store.navigation.commit('SET_TABS', [
      { label: 'Karte', to: `/parking_lot/${this.$route.params.id}` },
      { label: 'Metriken', to: `/parking_lot_metrics/${this.$route.params.id}` },
    ]);
  },
};
</script>
